import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import IconCircle from 'components/common/icon_circle'
import styles from './flat_progress.less'
import { formatPercent, formatMoney } from 'client/griffin'
import { ProgressMeter, HeadingText } from '@paypalcorp/pp-react'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/common/flat_progress')

class FlatProgress extends React.Component {
  static propTypes = {
    currencyCode: PropTypes.string,
    totalAmount: PropTypes.number,
    goalAmount: PropTypes.value,
    showPercentage: PropTypes.bool,
    showProgress: PropTypes.bool,
    compact: PropTypes.bool,
  }

  static defaultProps = {
    showPercentage: true,
    showProgress: true,
  }

  render() {
    const percentage = formatPercent(
      this.props.totalAmount / this.props.goalAmount
    )

    return (
      <div styleName="flat-progress">
        <div styleName="amount">
          <HeadingText size="lg">
            {formatMoney(this.props.currencyCode, this.props.totalAmount)}
          </HeadingText>
        </div>
        {this.props.showProgress ? (
          <ProgressMeter
            max={this.props.goalAmount}
            value={this.props.totalAmount}
          />
        ) : (
          this.props.compact && (
            <div styleName="meter">
              <div styleName="icon-circle-container">
                <IconCircle type="rocket" iconSize="big" />
              </div>
            </div>
          )
        )}
        {this.props.showPercentage && this.props.showProgress ? (
          <div styleName="percentage">
            <div styleName="percentage_num">{percentage}</div>
            <div styleName="percentage_description">
              {i18n('raised_amount_goal', {
                amount: formatMoney(
                  this.props.currencyCode,
                  this.props.goalAmount
                ),
              })}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

export default cssModules(FlatProgress, styles, { allowMultiple: true })
